module.exports = __webpack_public_path__ + "static/media/brahmendra ku.b96eeda6.jpg";